// Сохраняет информацию об источнике визита (utm, реферер)
// в локальном хранилище и на сервере.

import analytics from "./analytics";
import cookies from "../cookies";
import dom from "../dom";
import storage from "../storage";
import utm from "../utm";
import { getFingerprint } from "./fingerprint";

const $ = window.jQuery;

function saveLocal() {
    if (window.DA.user.id) {
        // save marketing data only for anonymous users
        return;
    }
    saveUtm();
    saveReferer();
    saveReferralId();
    // metrika ID: see analytics.js
    // signup point: see popups.js
}

function loadLocal() {
    return {
        referer: storage.get("referer"),
        signup_point: storage.get("signup_point"),
        utm_source: storage.get("utm_source"),
        utm_medium: storage.get("utm_medium"),
        utm_campaign: storage.get("utm_campaign"),
        metrika_id: storage.get("metrika_id"),
        referral_id: storage.get("referral_id"),
        fingerprint: getFingerprint({ hardwareOnly: true }),
    };
}

function saveUtm() {
    const params = utm.parse();
    if (utm.isEmpty(params)) {
        return;
    }
    storage.set("utm_source", params.utm_source);
    storage.set("utm_medium", params.utm_medium);
    storage.set("utm_campaign", params.utm_campaign);
}

function saveReferer() {
    let referer = document.referrer;
    if (referer.startsWith(window.location.origin)) {
        referer = "";
    }
    if (!referer) {
        return;
    }
    storage.set("referer", referer);
}

function saveReferralId() {
    if (storage.has("referral_id")) {
        return;
    }
    const referralId = dom.locationParams.get("ref");
    if (!referralId) {
        return;
    }
    storage.set("referral_id", referralId);
}

function saveRemote() {
    if (cookies.get("signup") !== "1") {
        return;
    }
    cookies.set("signup", "0");
    dom.callAfterWindowLoaded(() => {
        const signupReferrer = window.sessionStorage.getItem("signup_referrer");
        const SIGNUP_URL = signupReferrer?.includes("/blog/")
            ? signupReferrer
            : document.location.href;
        window.sessionStorage.removeItem("signup_referrer");
        analytics.reachGoal("SIGNUP_FINISH", { SIGNUP_URL });
    });
    const data = loadLocal();
    $.ajax({
        url: "/profile/refs/",
        type: "post",
        headers: { "X-CSRFToken": cookies.get("csrftoken") },
        data,
    });
}

dom.callAfterLoaded(() => {
    saveLocal();
    saveRemote();
});

export default {};
